import StoreLocator from 'store-locator';

import { $Elements, BrowserEvents, MapTiles } from './constants';

;(function($) {

	$Elements.document.on(BrowserEvents.page.enter, () => {

		// ---------- Simple Map ----------

		$('.simple-map').each(function() {

			let marker = this.dataset.marker;
			marker = (typeof marker === 'string') ? JSON.parse(marker) : marker;

			const map = new StoreLocator({
				stores: marker,
				selectors: {
					map: this.attributes.id.value,
				},
				map: {
					tiles: MapTiles,
					options: {
						maxZoom: 18,
					},
					markers: {
						icon: feature => L.icon({
							iconUrl: feature.properties.icon,
							iconSize: [178, 101],
							iconAnchor: [89, 101],
							popupAnchor: [0, -101],
						}),
					}
				}
			});
		});

	});

}(jQuery));
